import { io } from 'socket.io-client';
import { getAPIBaseURL } from '../store/baseQuery';

const URL = getAPIBaseURL()?.split('/v1')[0] ?? '';
export const socket = io(URL, {
  transports: ['websocket', 'polling']
});
